import type { UseQueryResult } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { ErrorState } from '@/components/ui';
import { ApiError } from '@/lib/api';
import { useI18n } from '@/lib/i18n';
import NotFound from '@/pages/public/NotFound';

/** Renders loading / error / 404 states consistently for a query. */
export function QueryState<T>({ query, loading, children }: { query: UseQueryResult<T>; loading: ReactNode; children: (data: T) => ReactNode }) {
  const { t } = useI18n();
  if (query.isPending) return <>{loading}</>;
  if (query.isError) {
    if (query.error instanceof ApiError && query.error.status === 404) return <NotFound />;
    return (
      <div className="container py-12">
        <ErrorState message={t('loadError')} onRetry={() => query.refetch()} retryLabel={t('retry')} />
      </div>
    );
  }
  return <>{children(query.data as T)}</>;
}
